module.exports = __webpack_public_path__ + "img/logo.3f955d1c.webp";